{
  "title": "Identify your work company",
  "explanation": "This identifies the company in your work reports. It does not buy a license, assign ownership or change vehicle/GPS permissions.",
  "collective": "Company (NIPC)",
  "individual": "Individual business (NIF)",
  "fiscalName": "Actual fiscal name",
  "companyName": "Company name",
  "collectiveNameRequired": "We could not validate the company automatically. Enter the company name to continue; it will be checked later.",
  "invalidIdentifier": "Enter a valid nine-digit fiscal identifier.",
  "confirmChange": "I confirm changing my work company; existing work retains its original company.",
  "confirmRequired": "Confirm the company change and provide the actual fiscal name when required.",
  "save": "Confirm work company",
  "retryAction": "Retry",
  "retry": "Unable to validate the work company. Retry or contact support.",
  "company": "Company",
  "driverNif": "NIF",
  "companyNipc": "NIPC",
  "companyTaxId": "Company tax ID",
  "profileLoading": "Loading profile",
  "sidebarLoadError": "Unable to load profile or work context. Retry or contact support.",
  "historicalCompanyMissing": "No company recorded for this open session",
  "license": "License",
  "companyLicense": "Company-funded",
  "personalMonth": "Personal - Monthly",
  "personalYear": "Personal - Annual",
  "personal": "Personal",
  "unknownLicense": "To confirm",
  "situation": "Situation",
  "return": "Return to work",
  "loading": "Loading work context",
  "identify": "Identify work company",
  "change": "Change work company",
  "corporateChange": "To retain company funding, ask the destination company for a company-funded invitation. This declaration cannot change your payer.",
  "selfPayDeclaration": "This declaration selects personal funding. It does not purchase coverage; company funding requires an invitation or company approval.",
  "invitationChange": "Current company: {{current}}. Accepting changes your work company to {{destination}}.",
  "invitationPaidPeriod": "If you already have a paid personal period, it remains valid until its end. Company coverage is scheduled for that date, subject to confirmed renewal cessation and valid company coverage.",
  "pending": {
    "work_company_required": "Identify your work company before starting new work.",
    "work_identity_unresolved": "Company identity needs validation. Retry or contact support.",
    "work_relationship_unresolved": "The work relationship needs verified support review.",
    "work_funding_unresolved": "The selected funding needs confirmation.",
    "awaiting_coverage": "Valid coverage is required for the next session.",
    "awaiting_renewal_confirmation": "The scheduled company funding is awaiting confirmation of personal renewal cessation.",
    "future_company_coverage_unavailable": "Future company coverage is pending. Your personal license remains valid until the paid period ends. Contact the company or support."
  }
}
